import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styles from "./VideoOverviewCard.module.scss";

// I want to use this for both LiveStreams and for videos
// contentType: stream or video
// video will be an object or an array including all the necessary info for the card
// what needs to be in the video object:
// channelID -> to get channel url
// channelName
// channelThumbnail
// videoThumbnail or streamUrl
//
function VideoOverviewCardV2({video, darkMode}) {
  const navigate = useNavigate();
  const params = useParams();
  const [videoState, setVideoState] = useState({});
  useEffect(() => {
    setVideoState(video);
  }, [video]);

  //  https://ipfs.io/ipfs/QmZCUoUd3t4mobDf4b7PNhxW7dzrbBZBgo3tGeiyTLRxoo

  function removeDecimals(timeString) {
    // Check if timeString is valid
    if (typeof timeString !== "string") {
      return "";
    }

    // Remove the decimal part after the dot
    const timeWithoutDecimals = timeString.split(".")[0];

    // Split by ":" and process each part
    const timeParts = timeWithoutDecimals.split(":");

    // If the first part is "00", remove it entirely
    if (timeParts[0] === "00") {
      timeParts.shift();
    } else if (timeParts[0].startsWith("0")) {
      // If the first part has a leading zero (e.g., "03"), remove the leading zero
      timeParts[0] = timeParts[0].slice(1);
    }

    // Join the parts back with ":"
    return timeParts.join(":");
  }


  return (
    <div className={styles.videoOverviewCard}>
      <Link
        style={{ textDecoration: "none" }}
        to={`/channel/${videoState["channelID"]}/${videoState["id"]}`}
      >
        <div
          className={styles.videoThumbnail}
          style={{ backgroundImage: `url(${videoState['thumbnail']})` }}
        >
          <div className={styles.duration}>{removeDecimals(videoState['duration'])}</div>
        </div>
      </Link>
      <div className={styles.videoCardInfo}>
        <Link
          style={{ textDecoration: "none" }}
          to={`/channel/${videoState["channelID"]}`}
        >
          <img
            src={videoState["pfp"]}
            className={styles.channelLogo}
            alt="logo"
          />
        </Link>
        <div className={styles.videoDesc}>
          <div className={styles.videoDesc}>
            <Link
              style={{ textDecoration: "none" }}
              to={`/channel/${videoState["channelID"]}/${videoState["id"]}`}
            >
              {/* Title */}
              {videoState["title"] ? (
                //FIX THIS STYLING ASAP ----------------------------------------
                <h4
                  className={styles.videoTitle}
                  style={{ color: darkMode ? "white" : "" }}
                >
                  {videoState["title"]}
                </h4>
              ) : (
                <h4
                  style={{ color: darkMode ? "white" : "" }}
                  className={styles.videoTitle}
                >
                  No Title
                </h4>
              )}
            </Link>

            {/* Channel Name */}
            <Link
              style={{ textDecoration: "none" }}
              to={`/channel/${videoState["channelID"]}`}
            >
              <h4
                className={styles.videoInfo}
                style={{ color: darkMode ? "#8e8d98" : "" }}
              >
                {videoState["name"]}
              </h4>
            </Link>
            {/* Date */}
            <h4
              className={styles.videoInfo}
              style={{ color: darkMode ? "#8e8d98" : "" }}
            >
              {/* <span>&#x231B;</span> */}
              {videoState["date"]}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoOverviewCardV2;
